"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Headline = (0, styles_1.styled)(Heading_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[theme.breakpoints.up('xs')] = {
            textAlign: 'center',
        },
        _b[theme.breakpoints.down('lg')] = __assign({}, theme.typography.h3),
        _b[theme.breakpoints.up('md')] = {
            textAlign: 'left',
        },
        _b);
});
exports.default = (0, DefaultPropsHoC_1.default)(Headline, {
    level: 2,
});
